export type OpenAIModel = (typeof OPENAI_MODELS)[number];

export const OPENAI_MODELS = [
  "gpt-6-sol",
  "gpt-6-luna",
  "gpt-5.6-terra",
  "gpt-5.6-luna",
  "gpt-5.4",
  "gpt-5.4-mini",
  "gpt-5.4-nano",
  "gpt-5.2",
  "gpt-4.1",
] as const;

export function isOpenAIModel(model: string): model is OpenAIModel {
  return OPENAI_MODELS.includes(model as OpenAIModel);
}

/**
 * Models that reject function tools on /v1/chat/completions unless reasoning is
 * off entirely; /v1/responses keeps both.
 */
const RESPONSES_API_ONLY_MODELS = new Set<OpenAIModel>([
  "gpt-6-sol",
  "gpt-6-luna",
  "gpt-5.6-terra",
  "gpt-5.6-luna",
]);

export function requiresResponsesApi(model: OpenAIModel): boolean {
  return RESPONSES_API_ONLY_MODELS.has(model);
}

export interface OpenAIProviderParams {
  /** Modify the likelihood of specified tokens appearing in the completion */
  logitBias?: Record<number, number>;
  /** Return the log probabilities of the tokens */
  logprobs?: boolean | number;
  /** Whether to enable parallel function calling during tool use */
  parallelToolCalls?: boolean;
  /** Whether to use structured outputs */
  structuredOutputs?: boolean;
  /** Whether to use legacy function calling */
  useLegacyFunctionCalling?: boolean;
  /** A unique identifier representing your end-user */
  user?: string;
  /** Automatically download images and pass the image as data to the model */
  downloadImages?: boolean;
  /** Simulates streaming by using a normal generate call */
  simulateStreaming?: boolean;
  /** Reasoning effort for reasoning models */
  reasoningEffort?: "low" | "medium" | "high";
  /** Whether OpenAI retains the response server-side (/v1/responses only) */
  store?: boolean;
}
